import { render, staticRenderFns } from "./ExpulsionPl.vue?vue&type=template&id=0fdc852f&scoped=true"
import script from "./ExpulsionPl.vue?vue&type=script&lang=js"
export * from "./ExpulsionPl.vue?vue&type=script&lang=js"
import style0 from "./ExpulsionPl.vue?vue&type=style&index=0&id=0fdc852f&prod&lang=css"
import style1 from "./ExpulsionPl.vue?vue&type=style&index=1&id=0fdc852f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc852f",
  null
  
)

export default component.exports